module.exports = __webpack_public_path__ + "static/media/5.29a13392.svg";